import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { useAcceptRewrite } from '@src/components/sco/PitchDeckAuditor/hooks/useAcceptRewrite';
import { DeckOverview } from '@src/components/sco/PitchDeckAuditor/main/DeckOverview';
import { LockedSlideAudit } from '@src/components/sco/PitchDeckAuditor/main/LockedSlideAudit';
import { PitchDeckToolbar } from '@src/components/sco/PitchDeckAuditor/main/PitchDeckToolbar';
import { SlideDetail } from '@src/components/sco/PitchDeckAuditor/main/SlideDetail';
import { usePitchDeckSlideAccess } from '@src/components/sco/PitchDeckAuditor/model/access';
import { PitchDeckView } from '@src/components/sco/PitchDeckAuditor/model/types';
export function PitchDeckMainPanel(t0) {
  const $ = _c(32);
  const {
    deck,
    activeSlideId,
    onSelectSlide
  } = t0;
  const layout = useParentAppLayout();
  const {
    acceptRewrite,
    clearRewrite,
    loading
  } = useAcceptRewrite();
  const {
    isSlideLocked
  } = usePitchDeckSlideAccess();
  let activeSlide;
  let onDiscuss;
  let t1;
  if ($[0] !== activeSlideId || $[1] !== deck || $[2] !== isSlideLocked || $[3] !== layout) {
    activeSlide = activeSlideId ? deck.slides.find(s => s.pitchDeckSlideId === activeSlideId) : null;
    let t2;
    if ($[7] !== layout) {
      t2 = () => layout.togglePanel?.("*-aside");
      $[7] = layout;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    onDiscuss = t2;
    t1 = !!activeSlide && isSlideLocked(activeSlide);
    $[0] = activeSlideId;
    $[1] = deck;
    $[2] = isSlideLocked;
    $[3] = layout;
    $[4] = activeSlide;
    $[5] = onDiscuss;
    $[6] = t1;
  } else {
    activeSlide = $[4];
    onDiscuss = $[5];
    t1 = $[6];
  }
  const slideLocked = t1;
  let t2;
  if ($[9] !== acceptRewrite || $[10] !== activeSlide || $[11] !== clearRewrite || $[12] !== deck || $[13] !== loading || $[14] !== slideLocked) {
    t2 = activeSlide ? <SlideDetail accepting={loading} locked={slideLocked} lockedContent={<LockedSlideAudit slide={activeSlide} />} slide={activeSlide} slideCount={deck.slideCount} onAccept={acceptRewrite} onClear={clearRewrite} /> : null;
    $[9] = acceptRewrite;
    $[10] = activeSlide;
    $[11] = clearRewrite;
    $[12] = deck;
    $[13] = loading;
    $[14] = slideLocked;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const slideDetail = t2;
  let t3;
  if ($[16] !== activeSlideId || $[17] !== deck || $[18] !== onDiscuss || $[19] !== onSelectSlide) {
    t3 = <PitchDeckToolbar activeSlideId={activeSlideId} deck={deck} onDiscuss={onDiscuss} onSelectSlide={onSelectSlide} />;
    $[16] = activeSlideId;
    $[17] = deck;
    $[18] = onDiscuss;
    $[19] = onSelectSlide;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: 4,
      md: 6
    };
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== activeSlide || $[23] !== deck || $[24] !== onSelectSlide || $[25] !== slideDetail) {
    t5 = activeSlide ? slideDetail : <DeckOverview deck={deck} onSelectSlide={onSelectSlide} />;
    $[22] = activeSlide;
    $[23] = deck;
    $[24] = onSelectSlide;
    $[25] = slideDetail;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== t5) {
    t6 = <Box marginX="auto" maxWidth="980px" padding={t4} width="full">{t5}</Box>;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== t3 || $[30] !== t6) {
    t7 = <Box position="relative" width="full"><VStack align="stretch" gap={0}>{t3}{t6}</VStack></Box>;
    $[29] = t3;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
}